$(function () {
    $('.tooltip-block').tooltip({
        html: "true",
        placement: "bottom"
    })
});